// Escala global do PDV — 1920×1080 é a resolução de referência (100%).
// Diferente do clamp() por vw/vh usado antes (cada propriedade com sua
// própria curva — o container encolhia mais rápido que a fonte, cortando
// texto), aqui TUDO (fonte, ícone, altura/largura de campo, padding, margin,
// gap, border-radius) multiplica o MESMO número, como se a interface fosse
// uma imagem sendo redimensionada — muda de tamanho, nunca de composição.
export const PDV_BASE_WIDTH = 1920;
export const PDV_BASE_HEIGHT = 1080;
export const PDV_SCALE_MIN = 0.58;
export const PDV_SCALE_MAX = 1.35;

// Calcula a escala (menor entre largura/altura, pra nunca estourar em
// nenhuma das duas direções) e publica em --pdv-scale, na raiz do
// documento — de lá qualquer componente lê via calc(Npx * var(--pdv-scale)),
// sem precisar de contexto/prop drilling.
export const updatePdvScale = (): void => {
  const scaleWidth = window.innerWidth / PDV_BASE_WIDTH;
  const scaleHeight = window.innerHeight / PDV_BASE_HEIGHT;
  const scale = Math.max(
    PDV_SCALE_MIN,
    Math.min(Math.min(scaleWidth, scaleHeight), PDV_SCALE_MAX),
  );
  document.documentElement.style.setProperty('--pdv-scale', scale.toString());
};

// Liga o cálculo da escala a QUALQUER mudança de tamanho — não só o resize
// da janela do navegador (que não dispara em todo ambiente, ex.: dentro de
// um container/iframe/webview que só muda de tamanho por CSS, sem redimensionar
// a window de verdade). ResizeObserver no <html> cobre esses casos também.
// Retorna a função de limpeza (remove listener + desconecta o observer).
export const watchPdvScale = (): (() => void) => {
  updatePdvScale();
  window.addEventListener('resize', updatePdvScale);

  let observer: ResizeObserver | undefined;
  if (typeof ResizeObserver !== 'undefined') {
    observer = new ResizeObserver(() => updatePdvScale());
    observer.observe(document.documentElement);
  }

  return () => {
    window.removeEventListener('resize', updatePdvScale);
    observer?.disconnect();
  };
};

// px pensado pra 1920×1080 (100%) → string CSS escalada. Usar em QUALQUER
// dimensão do PDV — nunca misturar um valor cru (px fixo) com um escalado
// dentro do mesmo componente, senão volta o problema de elemento e texto
// andando em velocidades diferentes.
export const pdvScale = (px: number): string => `calc(${px}px * var(--pdv-scale))`;

// Breakpoint de COMPOSIÇÃO (celular), não de escala contínua — diferente do
// @media por largura tentando corrigir componente a componente que o
// --pdv-scale substituiu (ver comentário em Pdv.tsx), esse aqui não briga
// com a escala: é só o ponto em que o layout troca de "colunas lado a lado"
// pra "empilhado", porque abaixo de ~600px não sobra largura nenhuma pra
// manter várias colunas/segmentos na mesma linha, não importa o quanto
// encolham. Dentro de cada composição (desktop OU celular), pdvScale
// continua sendo o único jeito de dimensionar as coisas.
export const MQ_PHONE = '@media (max-width:600px)';
